import React from "react";
import classes from "./Button.module.css"

const Button = (props) => {
    return (
        <button href={props.href} download={props.download} onClick={props.onClick} title={props.alt} style={{borderRadius: props.borderRadius || "10px", backgroundColor: props.bg || "", color: props.color || "#fff"}} className={classes.MainButton}>
            {props.title}
        </button>
    )
}

export default Button